<template>
    <div class="box">
        <div class="table__header p-3">
            <h4> Artwork Summary </h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="row p-3">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="suppliers" class="form-label"> Affiliates </label>
                            <v-select
                                    id="affiliates"
                                    label="name"
                                    index="id"
                                    placeholder="Select Affiliate"
                                    :options="affiliates"
                                    v-model="ArtworkFilters.selected_affiliate_id"
                                />
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                          <label for="" class="form-label"> Artwork Deadline</label>
                            <date-range-picker v-model="ArtworkFilters.invoiceDueDateRange" format="mm/dd/yyyy" opens="center" @update="checkOpenPicker('artwork_deadline')" class="form-control">
                                <!-- header slot-->
                                <div slot="header" slot-scope="header" class="slot-date-range-picker">
                                    <h3 class="m-0">Calendar header</h3> <span v-if="header.in_selection"> - in selection</span>
                                </div>
                                <!-- input slot (new slot syntax) -->
                                <template #input="picker">
                                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                </template>
                                <!-- date slot-->
                                <template #date="data">
                                    <span class="small">{{ data.date | dateCell }}</span>
                                </template>
                                <!-- ranges (new slot syntax) -->
                                <template #ranges="ranges">
                                    <div class="ranges">
                                        <ul>
                                        <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                                            <b>{{ name }}</b> <small class="text-muted">{{ range[0].toDateString() }} - {{ range[1].toDateString() }}</small>
                                        </li>
                                        </ul>
                                    </div>
                                </template>
                                <!-- footer slot -->
                                <div slot="footer" slot-scope="data" class="slot-date-range-picker">
                                    <div class="p-2">
                                        <b class="text-black">Calendar footer</b> {{ data.rangeText }}
                                    </div>
                                    <div style="margin-left: auto">
                                        <a @click="data.clickApply" v-if="!data.in_selection" class="btn btn-primary btn-sm">Choose current</a>
                                    </div>
                                </div>
                            </date-range-picker>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                          <label for="" class="form-label"> Placement Date </label>
                            <date-range-picker v-model="ArtworkFilters.artWorkPlacementDateRange" format="mm/dd/yyyy" opens="center" @update="checkOpenPicker('artwork_placement')" class="form-control">
                                <!-- header slot-->
                                <div slot="header" slot-scope="header" class="slot-date-range-picker">
                                    <h3 class="m-0">Calendar header</h3> <span v-if="header.in_selection"> - in selection</span>
                                </div>
                                <!-- input slot (new slot syntax) -->
                                <template #input="picker">
                                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                </template>
                                <!-- date slot-->
                                <template #date="data">
                                    <span class="small">{{ data.date | dateCell }}</span>
                                </template>
                                <!-- ranges (new slot syntax) -->
                                <template #ranges="ranges">
                                    <div class="ranges">
                                        <ul>
                                        <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                                            <b>{{ name }}</b> <small class="text-muted">{{ range[0].toDateString() }} - {{ range[1].toDateString() }}</small>
                                        </li>
                                        </ul>
                                    </div>
                                </template>
                                <!-- footer slot -->
                                <div slot="footer" slot-scope="data" class="slot-date-range-picker">
                                    <div class="p-2">
                                        <b class="text-black">Calendar footer</b> {{ data.rangeText }}
                                    </div>
                                    <div style="margin-left: auto">
                                        <a @click="data.clickApply" v-if="!data.in_selection" class="btn btn-primary btn-sm">Choose current</a>
                                        <a @click="clearDatePicker(type)" v-if="!data.in_selection" class="btn btn-danger btn-sm">Clear</a>
                                    </div>
                                </div>
                            </date-range-picker>
                        </div>
                    </div>
                    <div class="col-md-1">
                        <label for="checkbox" class="form-label">Created</label>
                        <br>
                        <label class="switch">
                            <input v-model="ArtworkFilters.is_created" id="checkbox" type="checkbox"/>
                            <span class="switch__slider"></span>
                        </label>
                    </div>
                    <div class="col-md-1">
                        <label for="checkbox" class="form-label">Sent</label>
                        <br>
                        <label class="switch">
                            <input v-model="ArtworkFilters.is_sent" id="checkbox" type="checkbox"/>
                            <span class="switch__slider"></span>
                        </label>
                    </div>
                    <div class="col-md-3" style="margin-top: 40px;">
                        <button class="button button--large  ms-2" @click="doSearch"><span>Search</span></button>
                        &nbsp;
                        <button class="button button--large btn-warning ms-2" @click="clearSearch"><span>Clear</span></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <vdtnet-table
                    ref="table"
                    :fields="fields"
                    :opts="options"
                    @viewAffiliate="viewAffiliate"
                    @viewAffiliateAdvertisement="viewAffiliateAdvertisement"
                    @recordProduct="recordProduct"
                    :key="artworkTableKey"
                    >
                </vdtnet-table>
            </div>
        </div>

        <div class="modal__bg" v-if="showArtworkPaymentModal == true"></div>
            <div class="modal" v-if="showArtworkPaymentModal == true">
                <AdvertisementInvoices :advertiseSizes="advertise_sizes"
                    :affiliateName="selectedAffiliate.name"
                    :affiliateID="selectedAffiliate.id"        
                    :products="products" 
                    :advertisement="selectedAdvertisement"
                    @syncProducts="syncProducts"   />
                    <button type="button" class="icon icon--unlink" v-on:click="showArtworkPaymentModal = false">Close</button>
            </div>
        <div class="modal__bg" v-if="showArtworkPaymentModal == true"></div>
    </div>
</template>
    
<script>
    
import 'datatables.net'
import 'datatables.net-select'
import VdtnetTable from 'vue-datatables-net'

import moment from 'moment';
    
import AdvertisementInvoices from '@/components/Affiliate/AdvertisementInvoices'

export default {
    name: 'ArtWorkListingSummary',
    components: {
        VdtnetTable,
        AdvertisementInvoices
    },
    props: {
        affiliates: Array,
        advertise_sizes:Array
    },
    data() {
        return {
            artworkTableKey: 0,
            options: {
                ajax: {
                    url: this.$api + 'summary/artwork-invoice',
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                },
                responsive: false,
                processing: true,
                searching: true,
                searchDelay: 1500,
                destroy: true,
                ordering: true,
                lengthChange: true,
                serverSide: true,
                dom: 'rtlip',
                autoWidth: false,
                lengthMenu: [ [5, 25, 50, 100, 500], [5, 25, 50, 100, 500] ],
                pageLength: 25,
                select: {
                    style: 'multi'
                }
            },
            fields: {
                affiliate_id: {
                    searchable: false,
                    label: 'Affiliate',
                    render: (data, type, row, meta) => {
                        if (row.affiliate_id) {
                            return  `<a href="/affiliates/edit/${ row.affiliate_id }" data-action="viewAffiliate">${ row.affiliate.name }</a>`   
                        } else {
                            return '-'
                        }
                    }
                },
                advertisement_size: {
                    searchable: false,
                    label: 'Size',
                    render: (data, type, row, meta) => {
                        if (row.advertise_size) {
                            return  `<strong>${row.advertise_size.size_name}</strong>`   
                        } else {
                            return '-'
                        }
                    }
                },
                advertisement_id: {
                    searchable: false,
                    label: 'Products',
                    render: (data, type, row, meta) => {
                        let products = '';
                        // console.log(row);
                        if (row.products.length > 0 ) {
                            products += '<ul>'
                            row.products.forEach(element => {
                                if (element.tour) {
                                    products += `<li>${element.tour.name }</li>`
                                }
                            });
                            products += '</ul>'
                            return products
                        } else {
                            return '--'
                        }
                    }
                },
                submission_deadline_date: {
                    searchable: false,
                    label: 'Deadline/Placement',
                    render: (data, type, row, meta) => {
                        return `<ul>
                            <li>Deadline : ${moment(String(data)).format('DD/MM/YYYY')}</li>
                            <li>Placement: ${moment(String(row.placemenet_date)).format('DD/MM/YYYY')} </li>
                        </ul>`
                        return 
                    }
                },
                invoice_amount: {
                    searchable: false,
                    label: 'Total Amount',
                    render: (data, type, row, meta) => {
                        return this.$options.filters.CurrencySymbol(row.currency_type) + Number(data).toFixed(2)
                    }
                },
                paid_status: {
                    searchable: false,
                    label: 'Paid ?',
                    render: (data) => {
                        let fully_paid = '<span class="badge badge-danger">No</span>'
                        if (data) {
                            fully_paid = '<span class="badge badge-success">Yes</span>'
                        }
                        return fully_paid
                    }
                },
                is_graphic_created: {
                    searchable: false,
                    label: 'Created ?',
                    render: (data) => {
                        let graphic_created = '<span class="badge badge-danger">No</span>'
                        if (data) {
                            graphic_created = '<span class="badge badge-success">Yes</span>'
                        }
                        return graphic_created
                    }
                },
                is_sent: {
                    searchable: false,
                    label: 'Sent ?',
                    render: (data) => {
                        let graphic_sent = '<span class="badge badge-danger">No</span>'
                        if (data) {
                            graphic_sent = '<span class="badge badge-success">Yes</span>'
                        }
                        return graphic_sent
                    }
                },
                created_at: {
                    searchable: false,
                    label: 'Products',
                    render: (data, type, row, meta) => {
                        return `<button class="button btn-warning p-2" data-action="recordProduct"> Product </a>
                            <button class="button btn-info p-2" data-action="viewAffiliateAdvertisement"> Advertisement </button>`
                    }
                },
            },
            affiliates: [],
            ArtworkFilters: {
                invoiceDueDateRange: {
                    startDate : '',
                    endDate : '',
                },
                artWorkPlacementDateRange: {
                    startDate : '',
                    endDate : '',
                },
            },
            showArtworkPaymentModal:false,
            selectedAdvertisement: {}, 
            selectedAffiliate: {},
            products: {}
        }
    },
    filters: {
        dateCell (value) {
            let dt = new Date(value)
            return dt.getDate()
        },
        date (val) {
            return val ? val.toDateString() : ''
        }
    },
    methods: {
        checkOpenPicker(type) {
            switch (type) {
                case 'artwork_deadline':
                    this.ArtworkFilters.invoiceDueDateRange.startDate = moment(this.ArtworkFilters.invoiceDueDateRange.startDate).format('YYYY-MM-DD')
                    this.ArtworkFilters.invoiceDueDateRange.endDate = moment(this.ArtworkFilters.invoiceDueDateRange.endDate).format('YYYY-MM-DD')
                    break;
                case 'artwork_placement':
                    this.ArtworkFilters.artWorkPlacementDateRange.startDate = moment(this.ArtworkFilters.artWorkPlacementDateRange.startDate).format('YYYY-MM-DD')
                    this.ArtworkFilters.artWorkPlacementDateRange.endDate = moment(this.ArtworkFilters.artWorkPlacementDateRange.endDate).format('YYYY-MM-DD')
                    break;

                default: break;
            }
        },
        viewAffiliate(data) {
            this.$router.push({ name: 'affiliate-edit', params: { id: data.affiliate_id }})
        },
        viewAffiliateAdvertisement(data) {
            this.$router.push({ name: 'affiliate-edit', params: { id: data.affiliate_id }, query: { advertisement_id: data.advertisement_id }})
        },
        recordProduct(data) {
            this.selectedAdvertisement = data
            this.products = data.products
            this.selectedAffiliate = data.affiliate
            this.showArtworkPaymentModal = true
        },
        doSearch() {
            const ajaxUrl = this.$api + 'summary/artwork-invoice'

            const queryString = new URLSearchParams();

            if(this.ArtworkFilters.selected_affiliate_id) {
                queryString.set('affiliate_id', this.ArtworkFilters.selected_affiliate_id);
            }

            if(this.ArtworkFilters.invoiceDueDateRange.startDate && this.ArtworkFilters.invoiceDueDateRange.endDate){
                queryString.set('due_date_start', this.ArtworkFilters.invoiceDueDateRange.startDate);
                queryString.set('due_date_end', this.ArtworkFilters.invoiceDueDateRange.endDate);
            }

            if(this.ArtworkFilters.artWorkPlacementDateRange.startDate && this.ArtworkFilters.artWorkPlacementDateRange.endDate){
                queryString.set('placement_start', this.ArtworkFilters.artWorkPlacementDateRange.startDate);
                queryString.set('placement_end', this.ArtworkFilters.artWorkPlacementDateRange.endDate);
            }

            if(this.ArtworkFilters.is_created){
                queryString.set('is_created', 'yes');
            }

            if(this.ArtworkFilters.is_sent){
                queryString.set('is_sent', 'yes');
            }

            const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

            // Update the datatable's AJAX URL with the Start Date & End Date query parameters
            this.options.ajax.url = urlWithParams;

            // Increment the tableKey to force re-render and fetch new data
            this.artworkTableKey++;
        },
        clearSearch() {
            this.ArtworkFilters =  {
                invoiceDueDateRange: {
                    startDate : '',
                    endDate : '',
                },
                artWorkPlacementDateRange: {
                    startDate : '',
                    endDate : '',
                },
            }

            this.options.ajax.url = this.$api + 'summary/artwork-invoice';
            this.artworkTableKey++
        },
        syncProducts(productObject) {
            if (productObject.length > 0) {
                this.products = productObject
            }
            this.doSearch()
        }
    }
}
</script>
    
<style scoped>
    .slot-date-range-picker {
      background-color: #aaa;
      padding: 0.5rem;
      color: white;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .slot-date-range-picker h3 {
      font-size: 1.0625rem;
    }
    
    .text-black {
      color: #000;
    }
</style>